import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './MyContentWizard.module.scss';

const cx = classNames.bind(styles);

export interface MyContentWizardProps {
  onClick: () => void;
}

const MyContentWizard = ({ onClick }: MyContentWizardProps): React.ReactElement => {
  return (
    <div className={cx('body')} data-testid="my-content-wizard">
      <span data-testid="my-content-wizard-text">All your saved content and preferences can be accessed here.</span>
      <Button mode={ButtonMode.PRIMARY} className={cx('wizard-button')} onClick={onClick}>
        Got it
      </Button>
    </div>
  );
};

export default MyContentWizard;
